import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../Layout/Layout";
// import LineChart from "./Charts/LineChart";
// import AreaChart from "./Charts/AreaChart";
import OrdersColumnChart from "./Charts/OrdersColumnChart";
// import POColumnChart from "./Charts/POColumnChart";
// import BarChart from "./Charts/BarChart";
import PieChart from "./Charts/PieChart";
// import DonutChart from "./Charts/DonutChart";
import { useNavigate } from "react-router-dom";
//Redux
import { useSelector } from "react-redux"; //useDispatch

//Serivce
// import ItemService from "../../services/supplier_appCommonService";
import customerItemService from "../../services/customer_appCommonService";
import LoaderSmall from "../../Components/LoaderSmall";

import {
  // formatNumberShort,
  formatToTwoDigits,
  getCurrentDate,
} from "../../common/Validations";
import DatePickerComponent from "./Charts/FilterComponent/DatePickerComponent";
// import SupplierConstants from "../../common/SupplierConstants";
import CustomerConstants from "../../common/CustomerConstants";
import { ComboboxField } from "../../Components/formElements/ComboboxField";
import "./customer.scss";


const Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    setUserRole(userData?.roles?.[0]?.roleId || "");
  }, [userData]);

  // sum one series data array
const sumSeries = (seriesItem) => {
  if (!seriesItem?.data) return 0;
  return seriesItem.data.reduce((sum, v) => sum + Number(v || 0), 0);
};

// get total by status name from dashboard response
const getTotalByStatusName = (dashboardData, statusName) => {
  const s = dashboardData?.series?.find((s) => s.name === statusName);
  return sumSeries(s);
};

  const navigateToMainPage = (page) => {
    if (page === "QUOTATION") {
      navigate(CustomerConstants.CUSTOMER_V4_HB_QUOTATION_LIST);
    } else if (page === "JOB") {
      navigate(CustomerConstants.CUSTOMER_V4_HB_JOB_LIST);
    } else if (page === "ESTIMATE") {
      navigate(
        CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST
      );
    } else if (page === "ESTIMATE") {
      navigate(CustomerConstants.CUSTOMER_V1_CUSTOMER_MASTER_LIST);
    } else if (page === "ENTRY") {
      navigate(CustomerConstants.CUSTOMER_V4_HB_ENTRY_LIST);
    } else if (page === "totalInvoiceCount") {
      navigate(CustomerConstants.CUSTOMER_V2_INVOICE_LIST);
    }
  };

  const employees = [
    { id: 1, name: "Gulnaz", code: "HBS-216", discription: "Gulnaz" },
    {
      id: 2,
      name: "Sandeep Kumar C",
      code: "HBS-221",
      discription: "Sandeep Kumar C",
    },
    {
      id: 3,
      name: "Sai Gnanaadeep B",
      code: "HBS-157",
      discription: "Sai Gnanaadeep B",
    },
  ];

  const [getDropdownData, setDropdownData] = useState("");
  const [getemployee, setEmployee] = useState({});

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

  const [filterShow, setFilterShow] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [totalPostDispatchCountStatus, setTotalPostDispatchCountStatus] =
    useState(false);
  // eslint-disable-next-line
  const [hideItem, setHideItem] = useState(false);

  //quotation count
  const [getQuotationCount, setQuotationCount] = useState("");
  const [getQuotationCountStatus, setQuotationCountStatus] = useState(false);

  //job count
  const [totalJobCount, setTotalJobCount] = useState("");
  const [totalJobCountStatus, setTotalJobStatus] = useState(false);

  //esitmationCount
  const [getTotalEstimationCount, setTotalEstimationCount] = useState("");
  const [getEstimationStatus, setEstimationStatus] = useState(false);
  const [jobtatusColChart, setjobtatusColChart] = useState("");
  const [jobStatusColChartStatus, setjobStatusColChartStatus] = useState(false);

  //column chart for quotation
  const [quotatationtatusColChart, setQuotatationtColChart] = useState("");

  const [quotatationStatusColChartStatus, setquotatationStatusColChartStatus] =
    useState(false);

  //column chart for estimation
  const [estimationatusColChart, setEstimationatusColChart] = useState("");
  const [getEstimationPieChart, setEstimationPieChart] = useState("");
  const [estimationStatusColChartStatus, setEstimationStatusColChartStatus] =
    useState(false);
  //dropdown data
  useEffect(() => {
    if (!getDropdownData) return;
    setEmployee((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.discription,
    }));
  }, [getDropdownData]);
  useEffect(() => {
    setEmployee({
      employee: userData?.firstName,
      employeeCode: userData?.userId,
      employeeDesc: userData?.firstName,
    });
  }, [userData]);

  // total Job Count
  const loadTotalJobCounts = async () => {
    setTotalJobStatus(true);
    let obj = {
      queryName: "totalJobDocCount",
    };

    await customerItemService.ChartCountCardHB(obj).then((item) => {
      if (item?.status === 200) {
        // console.log(">>item",item.data)
        setTotalJobCount(item?.count);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalJobStatus(false);
  };

  const [getEstimationDraft, setEstimationDraft] = useState("");
  const [getEstimationRevision, setEstimationRevision] = useState("");
  const [getEstimationCreated, setEstimationCreated] = useState("");
  const [getEstimationRevised, setEstimationRevised] = useState("");
  const [getEstimationRejected, setEstimationRejected] = useState("");
  const [getEstimationCanelled, setEstimationCancelled] = useState("");
  const [getEnquiryCount, setEnquiryCount] = useState("");
  // console.log("getEnquiryCount",getEnquiryCount)
  // console.log("Rejected",getEstimationRejected)

  // console.log("Revision",getEstimationRevision)
  // const loadEstimationPending = async () => {
  //   setEstimationStatus(true);
  //   let obj = {
  //     queryName: "totalEstimationCount",
  //     status: "Estimation Pending",
  //   };

  //   try {
  //     const item = await customerItemService.ChartCountCardHB(obj);

  //     if (item?.status === 200) {
  //       // console.log(">> Details res!", item);

  //       const data = item?.data || [];
  //       console.log("loadEstimationPending", data)
  //       const getCount = (statusName) =>
  //         data.find((entry) => entry.status === statusName)?.count || 0;

  //       setEstimationCreated(getCount("Estimation Created"));
  //       setEstimationDraft(getCount("Estimation Draft"));
  //       // setEstimationRevised(getCount("Estimation Revised"));
  //       setEstimationRevision(getCount("Estimation Revision"));
  //       // setEstimationPending(getCount("Estimation Pending"));
  //       setEstimationRevised(getCount("Estimation Revised"));
  //       setEstimationRejected(getCount("Estimation Rejected"));
  //     } else {
  //       toast.error(
  //         item?.message ||
  //           "Please try again for Total Estimation Pending Count",
  //         {
  //           duration: 4000,
  //           position: "top-right",
  //         }
  //       );
  //     }
  //   } catch (err) {
  //     toast.error("Something went wrong", {
  //       duration: 3000,
  //       position: "top-right",
  //     });
  //   }

  //   setEstimationStatus(false);
  // };

  const loadEnquiryCount = async () => {
    setEstimationStatus(true);
    let obj = {
      queryName: "Get_ENQUIRY_LIST",
      // status: "Estimation Pending",
    };

    try {
      const item = await customerItemService.generateCustomerQuery(obj);

      if (item?.status === 200) {
        const count = item?.total || 0;
        setEnquiryCount(count);
      } else {
        toast.error(
          item?.message ||
            "Please try again for Total Estimation Pending Count",
          {
            duration: 4000,
            position: "top-right",
          }
        );
      }
    } catch (err) {
      toast.error("Something went wrong", {
        duration: 3000,
        position: "top-right",
      });
    }

    setEstimationStatus(false);
  };

  const loadEstimationCount = async () => {
    setEstimationStatus(true);
    let obj = {
      queryName: "totalEstimationCount",
    };

    await customerItemService.ChartCountCardHB(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalEstimationCount(item?.count);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setEstimationStatus(false);
  };

  // loadCustomerCount
  const loadQuotationCount = async () => {
    setQuotationCountStatus(true);
    let obj = {
      queryName: "totalQuotationDocCount",
    };

    await customerItemService.ChartCountCardHB(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setQuotationCount(item?.count);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setQuotationCountStatus(false);
  };

  // Job Chart
  const jobsChart = async (filterData) => {
    setjobStatusColChartStatus(true);
    filterData.module = "job";
    filterData.chartType = "bar";

    await customerItemService.dashboardHb(filterData).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        item.data.module = "job";
        setjobtatusColChart(item?.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setjobStatusColChartStatus(false);
  };

  // quotation Chart
  const quotatinChart = async (filterData) => {
    setquotatationStatusColChartStatus(true);
    filterData.module = "quotation";
    filterData.chartType = "bar";

    await customerItemService.dashboardHb(filterData).then((item) => {
      // console.log(">> dashboard res!", item);
      if (item?.status === 200) {
        item.data.module = "quotation";
        setQuotatationtColChart(item?.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setquotatationStatusColChartStatus(false);
  };

  // estimation Chart
  // const estimationChart = async (filterData) => {
  //   setEstimationStatusColChartStatus(true);
  //   filterData.module = "estimation";
  //   filterData.chartType = "bar";

  //   await customerItemService.dashboardHb(filterData).then((item) => {
  //     // console.log(">> dashboard res!", item);
  //     if (item?.status === 200) {
  //       item.data.module = "estimation";
  //       setEstimationatusColChart(item?.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total User Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setEstimationStatusColChartStatus(false);
  // };

  const estimationChart = async (filterData) => {
  setEstimationStatusColChartStatus(true);
  const payload = { ...filterData, module: "estimation", chartType: "bar" };

  try {
    const item = await customerItemService.dashboardHb(payload);
    if (item?.status === 200) {
      const data = item.data;
      data.module = "estimation";
      setEstimationatusColChart(data);   // existing bar chart state

      // console.log(estimationChart, data);

      // NEW: monthly totals from dashboard series
      const totalDraft    = getTotalByStatusName(data, "Estimation Draft");
      const totalCreated  = getTotalByStatusName(data, "Estimation Created");
      const totalRevision = getTotalByStatusName(data, "Estimation Revision");
      const totalRevised  = getTotalByStatusName(data, "Estimation Rivised");
      const totalRejected = getTotalByStatusName(data, "Estimation Rejected");
      const totalCancelled= getTotalByStatusName(data, "Estimation Cancelled");

      setEstimationDraft(totalDraft);
      setEstimationCreated(totalCreated);
      setEstimationRevision(totalRevision);
      setEstimationRevised(totalRevised);
      setEstimationRejected(totalRejected);
      setEstimationCancelled(totalCancelled);
    } else {
      toast.error(item?.message || "Please try again for Estimation Chart", {
        duration: 4000,
        position: "top-right",
      });
    }
  } catch (e) {
    toast.error("Something went wrong in estimation chart", {
      duration: 3000,
      position: "top-right",
    });
  }

  setEstimationStatusColChartStatus(false);
};

  const attachQueryNames = (filterData) => {
    return {
      ...filterData,
      queryName1: "Yearly_Pie_Estimation_Chart",
      queryName2: "Monthly_Pie_Estimation_Chart",
      queryName:
        filterData.action === "Yearly"
          ? "Yearly_Pie_Estimation_Chart"
          : filterData.action === "Monthly"
          ? "Monthly_Pie_Estimation_Chart"
          : "Custom_Pie_Estimation_Chart",
    };
  };

  const pieChart = async (filterData) => {
    setEstimationStatusColChartStatus(true);

    // Add static + dynamic chart params
    let payload = {
      ...filterData,
      module: "estimation",
      chartType: "doughnut",
    };

    // Attach Yearly / Monthly / Custom query names
    payload = attachQueryNames(payload);

    // API Call
    await customerItemService.dashboardHb(payload).then((item) => {
      if (item?.status === 200) {
        item.data.module = "estimation";
        item.data.module = "job";
        item.data.module = "quotation";
        setEstimationPieChart(item?.data);
        // console.log(item?.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setEstimationStatusColChartStatus(false);
  };

  // On Filtered Data
  const handleFilterData = async (filter) => {
    await jobsChart(filter);
    await quotatinChart(filter);
    await estimationChart(filter);
    await pieChart(filter); // <-- ADD THIS
    //await loadEstimationPending(filter);
  };

  useEffect(() => {
    let defaultFilter = {
      // action: "Monthly",
      // month: currentMonth,
      // year: currentYear,
      module: "estimation",
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
      fromDate: "2025-12-01",
      toDate: "2026-12-20",
      searchTerm: getemployee?.employeeCode,
      // filterChartField: "userId",
    };
    const defaultFilterPiechart = {
      module: "Estimation",
      action: "Custom",
      chartType: "pie",
      queryName1: "Yearly_Pie_Estimation_Chart",
      queryName2: "Monthly_Pie_Estimation_Chart",
      queryName: "Custom_Pie_Estimation_Chart",
      month: currentMonth,
      year: currentYear,
      fromDate: "2025-12-01",
      toDate: "2026-12-29",
    };

    loadTotalJobCounts(); // job count
    loadEstimationCount(); //estimation count
    loadQuotationCount(); //quotation count
    //loadEstimationPending(); //estimation pending count
    loadEnquiryCount();

    jobsChart(defaultFilter);
    quotatinChart(defaultFilter);
    estimationChart(defaultFilter);
    pieChart(defaultFilterPiechart);

    //loadEstimationPending(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // useEffect(() => {

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);
  //chart user ID
  // const userIDChart = () => {
  //   jobsChart();
  //   quotatinChart();
  //   estimationChart();
  // };
  const loadChartsByUserId = async (filter) => {
    await Promise.all([
      jobsChart(filter),
      quotatinChart(filter),
      estimationChart(filter),
      loadTotalJobCounts(filter),
      //loadEstimationPending(filter),
      // pieChart(filter),   // <-- ADD THIS
    ]);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Dashboard detailed page</p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            <section className="section">
              <div className="row">
                {/* entry */}
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card entry-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Entry/Enquiry
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi-plus-circle"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={totalJobCountStatus} />
                          <h6>
                            {!totalJobCountStatus
                              ? formatToTwoDigits(getEnquiryCount || 0)
                              : ""}
                          </h6>
                          {/* <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span> */}
                          <span
                            className="text-muted small  ps-1"
                            onClick={() => navigateToMainPage("ENTRY")}
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Job */}
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card revenue-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Job
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-person-workspace "></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={totalJobCountStatus} />
                          <h6>
                            {!totalJobCountStatus
                              ? formatToTwoDigits(totalJobCount || 0)
                              : ""}
                          </h6>
                          {/* <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span> */}
                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() => navigateToMainPage("JOB")}
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Quotation */}
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Quotation
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-file-earmark-text"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={getQuotationCountStatus} />
                          <h6>
                            {!getQuotationCountStatus
                              ? formatToTwoDigits(getQuotationCount || 0)
                              : ""}
                          </h6>
                          {/* <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span> */}
                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() => navigateToMainPage("QUOTATION")}
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Estimate */}
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card customers-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Estimation
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-calculator"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={getEstimationStatus} />
                          <h6>
                            {!getEstimationStatus
                              ? formatToTwoDigits(getTotalEstimationCount || 0)
                              : ""}
                          </h6>
                          {/* <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span> */}
                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() => navigateToMainPage("ESTIMATE")}
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card estimation-draft-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Estimation Draft
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi-pencil-square"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          {/* {getEstimationDraft } */}
                          <LoaderSmall isLoading={getEstimationStatus} />
                          <h6>
                            {!getEstimationStatus
                              ? formatToTwoDigits(getEstimationDraft || 0)
                              : ""}
                          </h6>
                          {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}

                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() =>
                              navigateToMainPage("confirmedDispatchCount")
                            }
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card estimation-completed-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Estimation Created
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi-check-circle"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={getEstimationStatus} />
                          <h6>
                            {!getEstimationStatus
                              ? formatToTwoDigits(getEstimationCreated || 0)
                              : ""}
                          </h6>

                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() =>
                              navigateToMainPage("confirmedDispatchCount")
                            }
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card estimation-completed-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Estimation Revision
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-arrow-clockwise"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={getEstimationStatus} />
                          <h6>
                            {!getEstimationStatus
                              ? formatToTwoDigits(getEstimationRevision || 0)
                              : ""}
                          </h6>

                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() =>
                              navigateToMainPage("confirmedDispatchCount")
                            }
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card estimation-completed-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Estimation Revised
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi bi-patch-check"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={getEstimationStatus} />
                          <h6>
                            {!getEstimationStatus
                              ? formatToTwoDigits(getEstimationRevised || 0)
                              : ""}
                          </h6>

                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() =>
                              navigateToMainPage("confirmedDispatchCount")
                            }
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card estimation-rejected-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Estimation Rejected
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi-x-circle"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={getEstimationStatus} />
                          <h6>
                            {!getEstimationStatus
                              ? formatToTwoDigits(getEstimationRejected || 0)
                              : ""}
                          </h6>

                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() =>
                              navigateToMainPage("confirmedDispatchCount")
                            }
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 commTopButtonRightLeftPadding">
                  <div className="card info-card estimation-rejected-card">
                    <div className="card-body">
                      <h5 className="card-title">
                        Estimate Canceled
                        {/* <span>| This Year</span> */}
                      </h5>

                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i className="bi-x-circle"></i>
                        </div>
                        <div className="ps-3 d-flex align-items-center justify-content-center">
                          <LoaderSmall isLoading={getEstimationStatus} />
                          <h6>
                            {!getEstimationStatus
                              ? formatToTwoDigits(getEstimationCanelled || 0)
                              : ""}
                          </h6>

                          <span
                            className="text-muted small pt-2 ps-1"
                            onClick={() =>
                              navigateToMainPage("confirmedDispatchCount")
                            }
                          >
                            <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {filterShow && (
                <DatePickerComponent
                  getfiltereddata={handleFilterData}
                  cancelAction={() => setFilterShow(!filterShow)}
                />
              )}
              {/* Show team filter only when filterShow is FALSE */}
              {!filterShow && userRole === "DESIGN-MANAGER" && (
                <Row className="py-2 my-2">
                  <Col xs={12} md={3} lg={3} className="commLeftRightPadding">
                    <ComboboxField
                      label="Team "
                      iconName="bi-people-fill"
                      placeholder="Select"
                      data={employees}
                      id="employee"
                      iconClassName="dropdownIcon"
                      name="employee"
                      code="employeeCode"
                      description="employeeDesc"
                      setValue={getemployee?.employee}
                      getvalue={setDropdownData}
                    />
                  </Col>

                  <Col
                    xs={2}
                    md={2}
                    lg={2}
                    className="commLeftRightPadding d-flex justify-content-start align-items-end"
                  >
                    <button
                      className="btn Info"
                      style={{ height: "60%" }}
                      onClick={() =>
                        loadChartsByUserId({
                          module: "",
                          action: "Monthly",
                          month: currentMonth,
                          year: currentYear,
                          fromDate: "2025-09-01",
                          toDate: "2025-09-20",
                          searchTerm: getemployee?.employeeCode,
                        })
                      }
                    >
                      <i className="bi-search"></i>
                    </button>
                  </Col>
                </Row>
              )}
              {/* {userRole === "DESIGN-MANAGER" && (
                <Row className="py-2 my-2">
                  <Col xs={12} md={3} lg={3} className="commLeftRightPadding">
                    <ComboboxField
                      label="Team "
                    iconName="bi-people-fill"
                      placeholder="Select"
                      data={employees}
                      id="employee"
                      iconClassName="dropdownIcon"
                      name="employee"
                      code="employeeCode"
                      description="employeeDesc"
                      setValue={getemployee?.employee}
                      getvalue={setDropdownData}
                      // required={true}
                      // error={validation.type}
                    />
                  </Col>

                  <Col
                    xs={2}
                    md={2}
                    lg={2}
                    className="commLeftRightPadding d-flex justify-content-start align-items-end"
                  >
                    {" "}
                    <button
                      className="btn Info"
                      style={{ height: "60%"  }}
                      onClick={() =>
                        loadChartsByUserId({
                          module: "job",
                          action: "Monthly",
                          month: currentMonth,
                          year: currentYear,
                          fromDate: "2025-09-01",
                          toDate: "2025-09-20",
                          searchTerm: getemployee?.employeeCode,
                          // filterChartField: "userId",
                        })
                      }
                    >
                      {" "}
                     <i className="bi-search"></i>
                    </button>
                  </Col>
                </Row>
              )} */}
              <div className="row">
                {/* Esitmation column chart */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Esitmation</h5>

                      {/* <div id="columnChart"></div> */}
                      <LoaderSmall isLoading={estimationStatusColChartStatus} />
                      <h6>
                        {!estimationStatusColChartStatus ? (
                          <OrdersColumnChart
                            key="order"
                            chartdata={estimationatusColChart}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
                {/* job column chart */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Job</h5>

                      {/* <div id="columnChart"></div> */}
                      <LoaderSmall isLoading={jobStatusColChartStatus} />
                      <h6>
                        {!jobStatusColChartStatus ? (
                          <OrdersColumnChart
                            key="order"
                            chartdata={jobtatusColChart}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
                {/* quotation column chart */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Quotation</h5>

                      {/* <div id="columnChart"></div> */}
                      <LoaderSmall
                        isLoading={quotatationStatusColChartStatus}
                      />
                      <h6>
                        {!quotatationStatusColChartStatus ? (
                          <OrdersColumnChart
                            key="order"
                            chartdata={quotatationtatusColChart}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div>

                {/*  */}
                <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Statistics</h5>
                      <PieChart
                        chartData={{
                          labels:
                            getEstimationPieChart?.categories?.map(
                              (x) => x ?? "Unknown"
                            ) || [],
                          series: getEstimationPieChart?.series || [],
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Marketing Team</h5>

                      <div id="donutChart"></div>
                      <DonutChart />
                    </div>
                  </div>
                </div> */}
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Dashboard;
